import React, { useCallback } from 'react';
import { Keyboard, StyleSheet } from 'react-native';
import { isBefore, parseISO } from 'date-fns';
import { Button } from 'design-system';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setDeviceSettingsKey } from 'actions/deviceSettings';
import { accountTypeChoiceEvents } from 'features/funnel-events/utils';
import useNavigateToNextScreen from '../hooks/useNavigateToNextScreen';
import { selectTradingAccount } from '../reducers/selectors';
import { showReopenBlockedAlert } from '../utils/reopenBlock';
const SetupInvestmentAccountButton = ({ floating, noMarginBottom, isInTab, accountType, ...colorProps }) => {
    const dispatch = useAppDispatch();
    const tradingAccount = useAppSelector(selectTradingAccount);
    const investStatus = tradingAccount?.account?.status;
    const reopenBlockedUntil = tradingAccount?.account?.reopenBlockedUntil;
    const navigateToNextScreen = useNavigateToNextScreen();
    const handleOnboard = useCallback(() => {
        Keyboard.dismiss();
        if (investStatus === 'CLOSED') {
            // Wont happen but adding a check anyways
            if (!reopenBlockedUntil) {
                return;
            }
            const reopenBlockedUntilDate = parseISO(reopenBlockedUntil);
            if (isBefore(new Date(), reopenBlockedUntilDate)) {
                showReopenBlockedAlert(reopenBlockedUntilDate);
                return;
            }
        }
        dispatch(setDeviceSettingsKey('hasTriedSettingsUpInvest', true));
        if (accountType) {
            dispatch({
                type: 'SAVE_ONBOARDING_STATE',
                accountType,
            });
        }
        navigateToNextScreen({ choiceEvents: accountType ? [accountTypeChoiceEvents[accountType]] : [] });
    }, [investStatus, accountType, navigateToNextScreen, reopenBlockedUntil]);
    return (<Button {...colorProps} isInTab={isInTab} floating={floating} title="Get started" onPress={handleOnboard} containerStyle={noMarginBottom ? styles.button : undefined}/>);
};
const styles = StyleSheet.create({
    button: {
        bottom: 0,
    },
});
export default SetupInvestmentAccountButton;
